export const DEMORALIZING_WARCRY_SOUND_PATH = '/sounds/demoralizing_warcry.mp3';
/** Total ms before shockwave instance is removed from state (matches ripple tail + buffer) */
export const DEMORALIZING_WARCRY_EFFECT_DURATION_MS = 2800;
